'use client';

import * as React from 'react';
import { useRefWithInit } from '@base-ui-components/utils/useRefWithInit';
import { useDialogRoot } from "./useDialogRoot.js";
import { DialogRootContext, useDialogRootContext } from "./DialogRootContext.js";
import { DialogStore } from "../store.js";
import { getEmptyContext } from "../../floating-ui-react/hooks/useFloatingRootContext.js";
import { EMPTY_OBJECT } from "../../utils/constants.js";
import { jsx as _jsx } from "react/jsx-runtime";
const INITIAL_STATE = {
  open: false,
  dismissible: true,
  nested: false,
  popupElement: null,
  triggerElement: null,
  modal: true,
  descriptionElementId: undefined,
  titleElementId: undefined,
  openMethod: null,
  mounted: false,
  transitionStatus: 'idle',
  nestedOpenDialogCount: 0,
  triggerProps: EMPTY_OBJECT,
  popupProps: EMPTY_OBJECT,
  floatingRootContext: getEmptyContext()
};

/**
 * Groups all parts of the dialog.
 * Doesn’t render its own HTML element.
 *
 * Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
 */
export const DialogRoot = function DialogRoot(props) {
  const {
    children,
    open: openProp,
    defaultOpen: defaultOpenProp = false,
    onOpenChange,
    onOpenChangeComplete,
    dismissible = true,
    modal = true,
    actionsRef
  } = props;
  const parentDialogRootContext = useDialogRootContext(true);
  const nested = Boolean(parentDialogRootContext);
  const store = useRefWithInit(DialogStore.create, INITIAL_STATE).current;
  store.useControlledProp('open', openProp, defaultOpenProp);
  store.useSyncedValues({
    dismissible,
    nested,
    modal
  });
  store.useContextCallback('openChange', onOpenChange);
  store.useContextCallback('openChangeComplete', onOpenChangeComplete);
  useDialogRoot({
    store,
    actionsRef,
    parentContext: parentDialogRootContext?.store.context,
    onOpenChange
  });
  const contextValue = React.useMemo(() => ({
    store
  }), [store]);
  return /*#__PURE__*/_jsx(DialogRootContext.Provider, {
    value: contextValue,
    children: children
  });
};
if (process.env.NODE_ENV !== "production") DialogRoot.displayName = "DialogRoot";